import React, { useEffect } from "react"
import { useFormik } from "formik"
import * as yup from "yup"

import TextInput from "@components/ui/TextInput/TextInput"
import Button from "@components/ui/Button/Button"
import ErrorChip from "@components/ui/ErrorChip/ErrorChip"
import Loader from "@components/ui/Loader/BarLoader"

import styles from "./EditForm.module.sass"

export const userRoleFormSchema = yup.object({
  name: yup
    .string()
    .required("Filed is required")
    .matches(
      /^[a-zA-Z]+$/,
      "Must be a single word without digits or special characters"
    )
    .min(3, "Must be at least 3 chars length")
    .max(20, "Must be 20 chars maximum")
    .default("")
    .trim(),
})

export type FormData = yup.InferType<typeof userRoleFormSchema>

interface EditRoleFormProps {
  isLoading?: boolean
  className?: string
  errors?: FormData
  initialValues?: FormData
  onSubmit: (form: FormData) => void
}

const EditRoleForm: React.FC<EditRoleFormProps> = ({
  errors,
  isLoading,
  initialValues = userRoleFormSchema.getDefault(),
  onSubmit,
}) => {
  const formik = useFormik<FormData>({
    initialValues,
    validationSchema: userRoleFormSchema,
    onSubmit: (form: FormData) => {
      onSubmit(userRoleFormSchema.cast(form))
    },
  })

  useEffect(() => {
    if (errors) formik.setErrors(errors)
  }, [errors])

  return (
    <form className={styles.root} onSubmit={formik.handleSubmit}>
      <div className={styles.form}>
        <TextInput
          autoFocus
          name="name"
          placeholder="Enter role name..."
          value={formik.values.name}
          withError={!!(formik.touched.name && formik.errors.name)}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          after={
            formik.touched.name &&
            formik.errors.name && (
              <div className={styles.after}>
                <ErrorChip
                  message={formik.errors.name}
                  messagePlacement="left"
                />
              </div>
            )
          }
        />
        <Button type="submit" color="primary" disabled={isLoading}>
          Save {isLoading && <Loader />}
        </Button>
      </div>
    </form>
  )
}

export default EditRoleForm
